import { getAsyncHook, getReadySuccessHook, regReadyHook, setTitle } from '@weapp/utils';
import { checkCusApp, isFirefox } from '../utils';
import { registerHook } from './jsAPI';
import { esbMenuSettingCom, LayoutSDK, MenuSettingDialogCom } from '../lib';
import mainStore from '../components/main/store';
import { getAllModuleMenus, getAllModuleMixedMenus } from '../api/mainApi';
import { RootLayoutMenuData } from '@weapp/ui';
import { toJS } from 'mobx';
import { headerMenuStore, headerTenantStore } from "../components/main/navigation/store";
import { MailTypesMenuKeyMap } from '../components/main/navigation/types';
import { NavMenuItem } from '../components/main/navigation/widgets/quickToolbar/types';
import main from "../routes/pc/main";

export interface LayoutMenuSDKParamsProps {//setDataByKey 更新属性
    key: string,//更新key值
    value: any,//更新value
    source: string,//来源
    [propname: string]: any,//其他任意属性
}
/*
*事件注册名单
*moduleMenuItemClick 二级菜单点击
*appMenuItemClick 导航菜单点击
*allMenuItemClick 更多应用点击
*setAsideHidden 获取是否隐藏左侧菜单（特色主题）
*/
export type EventType = 'moduleMenuItemClick' | 'appMenuItemClick' | 'allMenuItemClick' | 'setAsideHidden';

// 允许注册的钩子, jsAPI中使用的名单
export const sdkHooksRules = [
    'asideMenusData',//左侧菜单
    'asideMenuActiveKey',//左侧高亮菜单
    'asideMenuExpandKeys',//侧边展开的菜单id
    'allAppMenusData',//更多应用菜单
    'navAppMenusData',//导航上显示的菜单
    'navAppMenuActiveData',//导航上显示的高亮菜单, 没有固定标记位，把高亮的整个菜单数据抛出来让特色门户自己处理）

    'themeMenuData',//特色主题与cusapp业务沟通新开的数据，主框架只中转不会做业务处理
    'customRouteMenus',//特色主题自定义路由数据

    'asideVisible',//左侧菜单显隐回调

    'navMenuItemRefresh',    //导航单个菜单更新
    'tenantListData'    //租户列表数据
]
/**
 * JS-SDK暴露组件
 */
class LayoutAsideSDK {

    // public asideMenuData: any = [];//菜单数据
    // public asideMenuActiveKey: string = "";//当前激活菜单数据
    // public asideMenuExpandKeys: any = []; //左侧菜单展开受控
    // public eventPool = {};
    private hookNameTypeList = isFirefox() ? (window.weappLayout?.LayoutSDK?.hookNameTypeList || {}) : {}//控制多个同类型事件对象，解决多个相同name的事件不生效处理
    private hookValue = isFirefox() ? (window.weappLayout?.LayoutSDK?.hookValue || {}) : {}//sdkHooksRules 数据存储
    private freeTimeLoads: Function[] = [];
    private freeTimeReady = false;

    /** 
     *  存入自定义事件（左侧菜单/顶部菜单点击等）
     *  type为固定值，与doEvent参数一致
     */
    setEvent = (type: EventType | string, ev: any) => {
        const successHook = getReadySuccessHook('weappLayout', type);
        successHook && successHook(ev);
    }
    /**
     *  默认渲染消息
     *  config:{type为渲染方式，callback为消息加载后回调,ignoreSysSetting是否忽略系统显示切换}
     */
    initIm = (config: { type: 'btn' | 'fullScreen', callback?: any, ignoreSysSetting?: boolean } = { type: 'btn' }) => {
        mainStore.loadIm((emUtil) => {
            if (config.type === 'btn') {
                emUtil.changeEmShowType('btn');
            } else if (config.type === 'fullScreen') {
                emUtil.changeEmShowType('nav');
            }
            config?.callback?.();
        }, config.ignoreSysSetting)
    }

    /**
     * 进入静默模式
     * 场景：提供pc客户端调用进入静默模式
     */
    setImSilent = (enable: boolean) => {
        if (mainStore.imSilent !== enable) {
            this.doEvent("layout.emReady", (emUtil: any) => {
                mainStore.setImSilent(enable);
                if (enable) {    //进入静默
                    if (mainStore.imTabMenuVisible) {
                        emUtil.initEmBtn();
                    }
                } else {    //退出静默
                    if (mainStore.imTabMenuVisible) {
                        emUtil.initEmNav();
                    }
                }
            })
            // const ee = window.weappLayout.default && window.weappLayout.default.ee || window.weappLayout.ee;
            // ee.emit('layout.getEmUtil', (emUtil: any) => {
            //     mainStore.setImSilent(enable);
            //     if (enable) {    //进入静默
            //         if (mainStore.imTabMenuVisible) {
            //             emUtil.initEmBtn();
            //         }
            //     } else {    //退出静默
            //         if (mainStore.imTabMenuVisible) {
            //             emUtil.initEmNav();
            //         }
            //     }
            // });
        }
    }

    setImEnable = (enable: boolean) => {
        mainStore.changeImEnable(enable);
    }

    /**
     * 获取工作消息显示方式
     * 场景: 客户端需要获取工作消息显示方式
     */
    getImShowType = () => {
        return mainStore.imTabMenuVisible ? "nav" : "btn";
    }

    /**
     * 2. 更新内部值
     * 场景：外部触发内部属性统一更新方法，并会主动触发一次监听
     * @param updateKey  需要更新数据的菜单key值，值与注册hook的名称保持一致
     * @param value  更新的新值
     */

    setDataByKey(params: LayoutMenuSDKParamsProps) {
        const existKeyList = this.hookNameTypeList[params.key];
        this.hookValue[params.key] = params;
        if (params.key === "asideMenusData") {
            if (params.source === 'cusapp') {
                mainStore.updateAsideMenuNew(params.value)
                if (params.asideDisplayInitMode) {//cusapp 返回asideDisplayInitMode，控制左侧菜单默认加载方式 'expand','fold','hidden'
                    switch (params.asideDisplayInitMode) {
                        case 'expand':
                            mainStore.updateCusappAsideHiddenByMode(false)
                            mainStore.changeAsideVisible(false) //参数值为是否hidden
                            break;
                        case 'collapse':
                            mainStore.updateCusappAsideHiddenByMode(false)
                            mainStore.changeAsideVisible(true) //参数值为是否hidden
                            break;
                        case 'hidden':
                            mainStore.updateCusappAsideHiddenByMode(true)
                            mainStore.changeAsideVisible(true) //参数值为是否hidden
                            break;
                        default:
                            mainStore.updateCusappAsideHiddenByMode(false)
                            mainStore.changeAsideVisible(false) //参数值为是否hidden
                            break;
                    }
                } else {//菜单配置还原
                    mainStore.updateCusappAsideHiddenByMode(false)
                    mainStore.changeAsideVisible(false) //参数值为是否hidden
                }
            }

        }
        if (existKeyList?.length) {//触发所有同类型注册的钩子
            existKeyList.forEach((currentKey: string) => {
                const hook = getAsyncHook('weappLayout', currentKey);
                hook && hook(params);
            });
        }

    }

    // 外部事件注册
    regHook = (hookname: string, callback: any) => {
        if (sdkHooksRules.includes(hookname)) {
            const hookNameAmount = this.hookNameTypeList[hookname]?.length || 0;
            if (!hookNameAmount) {
                this.hookNameTypeList[hookname] = [];
            }
            const key = `${hookname}_${hookNameAmount}`
            this.hookNameTypeList[hookname].push(key)
            registerHook(key, callback)
        }
    }
    getRulesData = (key: string) => {//手动触发获取已存在的数据
        return new Promise((resolve, reject) => {
            resolve(this.hookValue[key])
        })
    }

    //是否是eb应用展示
    isEsbModule = (): boolean => {
        return checkCusApp();
    }
    //设置左侧菜单是否隐藏
    setAsideHidden = (hidden: boolean) => {
        mainStore.updateHiddenAside(hidden);
    }

    //触发PC锁定
    setPCLocked = (lock: boolean) => {
        mainStore.setPCLocked(lock);
    }

    lockPage = (callback?: Function) => {
        mainStore.lockPage(callback);
    }

    //工具类集合
    utils = {
        'toPortal': () => { mainStore?.toPortal && mainStore?.toPortal(); },//门户菜单跳转
        'setLayoutTitle': (config: any) => { this.setLayoutTitle(config) },
        'showImContent': () => { mainStore?.showImContent && mainStore?.showImContent(); },//IM打开内容方法
        'setImContentVisible': (visible: boolean) => { mainStore.changeImTabContentVisible(visible) },
        'getImShowOnNavigation': (data?: NavMenuItem) => { return mainStore?.getImShowOnNavigation && mainStore?.getImShowOnNavigation(data); },//IM打开内容方法
        'getImShowOnNavigationAsync': (callback: (showOnNav: boolean) => void) => {
            if (headerMenuStore.navMenusLoaded) {
                callback?.(this.utils.getImShowOnNavigation())
            } else {
                const ee = window.weappLayout.default && window.weappLayout.default.ee || window.weappLayout.ee;
                ee.on('layout.navMenuLoaded', () => {
                    callback?.(this.utils.getImShowOnNavigation())
                });
            }
        },//IM打开内容方法
        // 'getImCount': () => { return mainStore?.imCounter || 0 },//获取IM未读数量的方法
        'quickLogout': () => { mainStore?.quickLogout && mainStore?.quickLogout(); },//快捷菜单-退出登录方法
        'getMailMenuKeyMap': () => { return MailTypesMenuKeyMap },//工具栏邮箱枚举map
        'quickMenuClick': (data: NavMenuItem) => { mainStore?.quickMenuClick && mainStore?.quickMenuClick(data); },//右键菜单点击（邮箱点击与微信号点击不在此方法内）
        'getMoreAppShowType': (data: NavMenuItem) => { return mainStore?.getMoreAppShowType && mainStore?.getMoreAppShowType(data); },//更多应用菜单展示方式
        'moreAppShowTilingClick': (show: boolean) => { mainStore?.updateMoreAppTilingPageShow && mainStore?.updateMoreAppTilingPageShow(show); },//更多应用平铺时点击调用方式
        //获取自定义路由组件数据（cusapp自定义组件等场景 路由-组件数据映射关系）
        'getCustomRouteMenus': () => { return [...toJS(mainStore.customRouteMenus || [])]; },
        'getRootLayoutProps': () => { return mainStore?.getRootLayoutProps(); }//rootlayout props 属性抛出
    }
    setLayoutTitle = (config: any) => {
        if (config.title) {
            window.weappLayout.layoutTitle = config.title;
            setTitle({ title: config.title })
        }
    }
    //获取菜单设置组件
    getMenusSetting = () => {
        const isEsbModule = this.isEsbModule();
        return {
            source: isEsbModule ? 'esb' : 'layout',
            comp: isEsbModule ? esbMenuSettingCom : MenuSettingDialogCom
        }
    }
    getPromiseDataByType = (type: string) => {
        const getRequesetByKey = {
            'allModuleMenus': getAllModuleMenus,
            'allModuleMixedMenus': getAllModuleMixedMenus,
        }

        return getRequesetByKey[(type as keyof typeof getRequesetByKey)]?.();
    }
    //自定义路由组件数据（cusapp自定义组件等场景 路由-组件数据映射关系）
    updateRouteMenus = (routeMenus: RootLayoutMenuData[]) => {
        this.hookValue['customRouteMenus'] = routeMenus;
        const existKeyList = this.hookNameTypeList['customRouteMenus'];
        if (existKeyList?.length) {//触发所有同类型注册的钩子
            existKeyList.forEach((currentKey: string) => {
                const hook = getAsyncHook('weappLayout', currentKey);
                hook && hook(routeMenus);
            });
        }
        mainStore.updateRouteMenus(toJS(routeMenus));//cusapp菜单更新
        mainStore.updateRouteMenus(toJS(routeMenus));//cusapp菜单更新
    }
    /*
      @param type  事件key
    * @param param  参数
    */
    doEvent = (type: EventType | string, param?: any) => {
        if (type === 'moduleMenuItemClick') {//左侧菜单点击区分来源标志
            const suffix = (this.isEsbModule() || param?.data?.pageType) ? '_cusapp' : '_layout';//主框架与esb 从此处分发调用
            type = type + suffix;
        }
        regReadyHook('weappLayout', type, {
            success: (ev) => {
                if (type.indexOf('moduleMenuItemClick') === 0) {
                    ev(param?.data?.id, param?.data, param?.e || param?.event);
                } else {
                    ev(param);
                }
            },
            //暂不考虑失败情况
            failed: () => {
                console.log('未能获取注册事件')
            }
        });
    }
    /**
   * 刷新导航工具菜单（角标数量显示）
   * @param menuKey 导航菜单项唯一标识
   */
    refreshNavMenuItemByMenuKey = (menuKey: string) => {
        headerMenuStore.updateNavMenuItemByMenuKey(menuKey);
        headerMenuStore.refreshNavMenu();
        LayoutSDK.setDataByKey({ key: "navMenuItemRefresh", value: menuKey, source: 'layout' })
    }
    /**
     * 左侧菜单展示类型：mixed 混合菜单 regular 单业务模块菜单（默认）
     * @param menuType 左侧菜单展示类型
     */
    changeThemeMenuType = (menuType: string) => {
        mainStore?.changeThemeMenuType?.(menuType);
    }
    /**
     * 更新应用展示设置配置数据
     */
    updateAppMenusConfig = () => {
        headerMenuStore?.getDisplayCommonConfig();
        headerMenuStore?.getCustomAPPmenus();
        headerMenuStore?.getAllAppMenus();
    }
    updateAppDropMenuConfig = () => {
        headerMenuStore?.getAllAppMenus();
    }
    /**
     * 注册闲时加载项
     */
    regFreeTimeLoad = (loadCall: Function) => {
        if (this.freeTimeReady) {
            loadCall();
        } else {
            this.freeTimeLoads.push(loadCall);
        }
    }

    /**
     * 触发主框架闲时加载项
     */
    doFreeTimeLoad = () => {
        if (!this.freeTimeReady) {
            this.freeTimeReady = true;
            this.freeTimeLoads.forEach((loadCall) => {
                loadCall();
            })
        }
    }
    /**
     * 更新更多应用显示方式
     */
    refreshAppMenu = (type?: string) => {
        headerMenuStore?.refreshAppMenu();
        if (type) {
            mainStore?.setMoreAppType(type);
        }
    }

    /**
     * 获取租户列表
     */
    getTenantListData = () => {
        return toJS(headerTenantStore.tenantList);
    }

    getNavMenuData = () => {
        return toJS(headerMenuStore.navMainMenus);
    }

    setClientToolVisible = (visible: boolean) => {
        mainStore.setClientToolShow(visible);
    }

}
const instance = new LayoutAsideSDK();

// 模拟测试
// instance.setEvent('test', (params: any) => {
//     alert(params)
// });


export default instance;

